// extracted by mini-css-extract-plugin
module.exports = {"task":"styles_task__3vfzs","valueType":"styles_valueType__1Ow-x","criteria":"styles_criteria__1VvUU"};